import isNumber from 'lodash/isNumber';

import {TooltipFormatterParams} from 'common/charts/visualization/pie-chart/types';
import {truncateMiddle} from 'common/util/string';
import {TooltipItemType} from 'common/components/chart-tooltip/types';
import {commaizeNumber, htmlEncodeString} from 'common/util';

export function defaultTooltipFormatter({name, value, percent, color}: TooltipFormatterParams): string {
  const formatPercent = (decimal) => {
    return Math.round(decimal * Math.pow(10, 2)) / Math.pow(10, 2) + `%`;
  };

  const sections = [
    {
      rows: [
        {
          items: [
            {
              text: truncateMiddle(name, 45),
              type: TooltipItemType.Strong,
            },
          ],
        },
      ],
    },
    {
      rows: [
        {
          items: [
            {
              text: isNumber(value) ? commaizeNumber(value) : ``,
              type: TooltipItemType.Data,
            },
          ],
        },
        {
          items: [
            {
              text: isNumber(percent) ? formatPercent(percent) : ``,
              type: TooltipItemType.Data,
            },
            {
              text: `of total`,
              type: TooltipItemType.Text,
            },
          ],
        },
      ],
    },
  ];

  return `<mp-chart-tooltip title-color="${color}" sections='${htmlEncodeString(JSON.stringify(sections))}'>`;
}
